/**
 * ``/workspace/projects/$projectId`` — per-project management surface.
 *
 * Single-column accordion with 6 sections (Persona, Knowledge, Artifact
 * gallery, Tasks, HyperMem timeline, Automazioni). Phase 0 ships the
 * skeleton; each section gets its real body in the matching Phase 1-3
 * deploy without any chrome refactor here.
 *
 * Architectural note: the chat pane stays mounted on the LEFT side of the
 * authed shell — this page lives in the workspace pane (right side, 62%
 * in split / flex-1 in canvas-led). The user can chat in the project
 * context simultaneously; the project lens is kept in sync via a
 * ``setCurrentProjectId`` effect inside ``ProjectDetailPage``.
 */

import { createFileRoute } from "@tanstack/react-router";

import { ProjectDetailPage } from "@/features/projects";

export const Route = createFileRoute("/_authed/workspace/projects/$projectId")({
  component: ProjectDetailPage,
});
